import React from "react";

const Banner = () => {
  return (
    <>
      <div className="outter_layer_builders latestbanner">
        <section className="banner-main">
          <img
            src="\assets\homepage\banner\banner-shadow.png"
            alt="img"
            className="img-fluid banner-shadow"
          />
          <video
            className="main-banner-video"
            muted="muted"
            playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo"
          >
            <source src="\assets\bannervideo.mp4" type="video/mp4" />
          </video>
          <div className="custom-container">
            <div className="inner-banner">
              <div className="left-side">
                <div>
                  <h2>Get <span style={{ color: "#E6FF00" }}>$RAIN</span> Token Now</h2>
                  <p>
                    Join the revolution — be part of the ecosystem driving
                    rewards, growth, <br /> and community power.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Banner;
